import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import Logo from "@/components/Logo";
import { toast } from "sonner";

export default function ResetPassword() {
  const nav = useNavigate();
  const token = new URLSearchParams(useLocation().search).get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return setError("Passwords do not match");
    setBusy(true); setError("");
    try {
      const { data } = await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success(data.message);
      nav("/login");
    } catch (err) {
      const d = err?.response?.data?.detail;
      setError(typeof d === "string" ? d : Array.isArray(d) ? d.map((x) => x.msg).join(" ") : "Could not reset password");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F9FE] px-4">
      <Card className="w-full max-w-md p-8 bg-white border-slate-200 shadow-lg">
        <Link to="/" className="flex items-center gap-2 mb-6"><Logo size={44} /><span className="font-display font-extrabold text-[#0A2A5E] text-lg">LUMIS HR</span></Link>
        <h1 className="font-display text-2xl font-bold text-[#0A2A5E]">Choose a new password</h1>
        {!token ? (
          <p data-testid="reset-missing-token" className="mt-4 text-sm text-rose-700">This reset link is incomplete. <Link to="/forgot-password" className="underline">Request a new one</Link>.</p>
        ) : (
          <form onSubmit={submit} className="mt-4 space-y-4">
            <div>
              <Label htmlFor="pw">New password</Label>
              <Input id="pw" data-testid="reset-password" type="password" value={pw} onChange={(e) => setPw(e.target.value)} required minLength={8} className="mt-1" />
              <p className="text-[11px] text-slate-500 mt-1">At least 8 characters.</p>
            </div>
            <div>
              <Label htmlFor="pw2">Confirm new password</Label>
              <Input id="pw2" data-testid="reset-password-confirm" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} required minLength={8} className="mt-1" />
            </div>
            {error && <p data-testid="reset-error" className="text-sm text-rose-700">{error}</p>}
            <Button data-testid="reset-submit" type="submit" disabled={busy} className="w-full bg-[#0A2A5E] hover:bg-[#0F3F8A] text-white h-11">{busy ? "Updating…" : "Update password"}</Button>
          </form>
        )}
        <div className="mt-6 text-sm text-center text-slate-600"><Link to="/login" className="text-[#0A2A5E] font-semibold hover:underline">Back to sign in</Link></div>
      </Card>
    </div>
  );
}
